export type SessionExpiredReason = "inactivity" | "unauthenticated";

type SessionExpiredListener = (reason: SessionExpiredReason) => void;

let pendingReason: SessionExpiredReason | null = null;
const listeners = new Set<SessionExpiredListener>();

export function triggerSessionExpired(reason: SessionExpiredReason) {
  if (typeof window === "undefined") return;
  if (pendingReason === reason || pendingReason === "inactivity") return;

  pendingReason = reason;
  listeners.forEach((listener) => listener(reason));
}

export function subscribeSessionExpired(listener: SessionExpiredListener): () => void {
  listeners.add(listener);

  if (pendingReason !== null) {
    const replayReason = pendingReason;
    queueMicrotask(() => {
      if (pendingReason === replayReason && listeners.has(listener)) listener(replayReason);
    });
  }

  return () => {
    listeners.delete(listener);
  };
}

export function getPendingSessionExpiredReason(): SessionExpiredReason | null {
  return pendingReason;
}

export function clearPendingSessionExpired() {
  pendingReason = null;
}

let pendingLogoutController: AbortController | null = null;

export function trackPendingLogout(): AbortSignal {
  pendingLogoutController = new AbortController();
  return pendingLogoutController.signal;
}

export function settlePendingLogout(signal: AbortSignal) {
  if (pendingLogoutController?.signal === signal) pendingLogoutController = null;
}

export function abortPendingLogout() {
  pendingLogoutController?.abort();
  pendingLogoutController = null;
}
